import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { BillingEntity } from 'src/features/billing/utils/types';
import { ListResponseAPI } from 'src/lib/queries';

const RESOURCE = '/customers/billing-entity/';

type QueryFnType = typeof queryFn;

const queryFn = ({ ...params }: ListDTO): Promise<ListResponseAPI<BillingEntity>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends ListDTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_BILLING_ENTITIES_RESOURCE, useQueryHook as useListBillingEntities };
